import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type BlockingProgressDialogData = {
  title?: string;
  message?: string;
  icon?: string;
};

@Component({
  selector: 'app-blocking-progress-dialog',
  templateUrl: './blocking-progress-dialog.component.html',
  styleUrls: ['./blocking-progress-dialog.component.scss']
})
export class BlockingProgressDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: BlockingProgressDialogData) {}

  get title(): string {
    return this.data?.title || 'Processando...';
  }

  get message(): string {
    return this.data?.message || 'Aguarde, estamos processando sua solicitação.';
  }
}

